import {
  Sidebar,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarScrollWrapper,
  SidebarSpace,
} from '@backstage/core-components';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import { SidebarLogo } from './SidebarLogo';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import BusinessIcon from '@material-ui/icons/Business';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import StorefrontIcon from '@material-ui/icons/Storefront';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import { SidebarSearchModal } from '@backstage/plugin-search';
import { UserSettingsSignInAvatar } from '@backstage/plugin-user-settings';
import { NotificationsSidebarItem } from '@backstage/plugin-notifications';
import { useIsAdmin } from '../auth/AdminRouteGuard';
import { useIsExternalClient } from '../externalUsers/useIsExternalClient';
import { ExternalClientRouteGuard } from '../externalUsers/ExternalClientRouteGuard';

export const SidebarContent = NavContentBlueprint.make({
  params: {
    component: function TechneSidebar({ navItems }) {
      const { isAdmin, loading: adminLoading } = useIsAdmin();
      const { isExternalClient, loading: externalLoading } =
        useIsExternalClient();

      const nav = navItems.withComponent(item => (
        <SidebarItem icon={() => item.icon} to={item.href} text={item.title} />
      ));

      // Skipped items (rendered manually / elsewhere)
      nav.take('page:search');
      nav.take('page:notifications');
      nav.take('page:techdocs');
      nav.take('page:backoffice');
      nav.take('page:cliente-externo');
      nav.take('page:secret-manager');
      nav.take('page:lojinha');
      nav.take('page:aprovacoes');

      if (!externalLoading && isExternalClient) {
        return (
          <>
            <ExternalClientRouteGuard />
            <Sidebar>
              <SidebarLogo />
              <SidebarDivider />
              <SidebarGroup label="Menu" icon={<MenuIcon />}>
                <SidebarItem
                  icon={BusinessCenterIcon}
                  to="/cliente-externo"
                  text="Cliente externo"
                />
              </SidebarGroup>
              <SidebarSpace />
              <SidebarDivider />
              <SidebarGroup
                label="Settings"
                icon={<UserSettingsSignInAvatar />}
                to="/settings"
              >
                {nav.take('page:user-settings')}
              </SidebarGroup>
            </Sidebar>
          </>
        );
      }

      return (
        <>
          <ExternalClientRouteGuard />
          <Sidebar>
            <SidebarLogo />
            <SidebarGroup label="Search" icon={<SearchIcon />} to="/search">
              <SidebarSearchModal />
            </SidebarGroup>
            <SidebarDivider />
            <SidebarGroup label="Menu" icon={<MenuIcon />}>
              {nav.take('page:app/home')}
              {nav.take('page:catalog')}
              {nav.take('page:scaffolder')}
              {nav.take('page:documentation')}
              {!adminLoading && isAdmin ? (
                <SidebarItem
                  icon={BusinessIcon}
                  to="/backoffice"
                  text="Backoffice"
                />
              ) : null}
              {!adminLoading && isAdmin ? (
                <SidebarItem
                  icon={AssignmentTurnedInIcon}
                  to="/aprovacoes"
                  text="Aprovações"
                />
              ) : null}
              <SidebarItem
                icon={VpnKeyIcon}
                to="/secret-manager"
                text="Secret Manager"
              />
              <SidebarItem
                icon={StorefrontIcon}
                to="/lojinha"
                text="Lojinha"
              />
              <SidebarDivider />
              <SidebarScrollWrapper>
                {nav.rest({ sortBy: 'title' })}
              </SidebarScrollWrapper>
            </SidebarGroup>
            <SidebarSpace />
            <SidebarDivider />
            <NotificationsSidebarItem />
            <SidebarDivider />
            <SidebarGroup
              label="Settings"
              icon={<UserSettingsSignInAvatar />}
              to="/settings"
            >
              {nav.take('page:app-visualizer')}
              {nav.take('page:user-settings')}
            </SidebarGroup>
          </Sidebar>
        </>
      );
    },
  },
});
